import React from 'react';
import styled from 'styled-components';
import {mobileMediaQuery, tabletMediaQuery} from '../../styles';
import DKidsLivePlayer from './DKidsLivePlayer';

const DKidsLive = ({live}) => {
    return (
        <Container>
            <LivestreamBG />
            <Blend1 />
            <Blend2 />
            <Stars />
            <Content>
                <DKidsLivePlayer live={live} />

                <TextContainer>
                    <Title>{live.description}</Title>
                    <Subtitle>{live.title}</Subtitle>
                </TextContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    height: 450px;
    display: flex;

    ${tabletMediaQuery} {
        height: 350px;
    }

    ${mobileMediaQuery} {
        height: 310px;
    }
`;

const LivestreamBG = styled.div`
    width: 100%;
    height: 564px;
    background: url(${require('../../assets/dkids/livestream_bg.png')});
    background-size: cover;
`;

const Blend1 = styled.div`
    position: absolute;
    width: 100%;
    height: 269px;
    top: 305px;
    background: linear-gradient(
        180deg,
        rgba(20, 31, 154, 0.2) 0%,
        #4757ff 100%
    );
    transform: matrix(-1, 0, 0, 1, 0, 0);
`;

const Blend2 = styled.div`
    position: absolute;

    width: 100%;
    height: 220px;
    top: 380px;

    background: linear-gradient(
        1.04deg,
        rgba(0, 0, 0, 0) 0.89%,
        rgba(0, 0, 0, 0.17) 82.74%,
        rgba(0, 0, 0, 0) 99.11%
    );
    transform: matrix(1, 0, 0, -1, 0, 0);
`;

const Stars = styled.img.attrs({
    src: require('../../assets/dkids/stars_bg.png'),
})`
    position: absolute;
    top: 253px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
`;

const Content = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    top: 100px;
    max-width: 1440px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    align-self: center;
    justify-content: center;
    align-items: center;
    padding: 0 25px;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 65px;

    ${tabletMediaQuery} {
        margin-left: 40;
    }
    ${mobileMediaQuery} {
        display: none;
    }
`;

const Title = styled.div`
    font-family: DKIDS;
    font-size: 26px;
    margin-bottom: 12px;

    ${tabletMediaQuery} {
        font-size: 20px;
    }
`;

const Subtitle = styled.div`
    font-family: Mont;
    font-weight: 300;
    font-size: 24px;

    ${tabletMediaQuery} {
        font-size: 16px;
    }
`;

export default DKidsLive;
